export const AHUD_PURPLE = '#A335B3';
export const AHUD_AMBER_25 = '#F1DFC0';
export type LITE_COLORS = typeof AHUD_PURPLE | typeof AHUD_AMBER_25;
